/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Row, Col, Container, Form, Button, InputGroup } from "react-bootstrap";
import { Base } from "../../../components/RootLayout";
import { numberOnly, priceDecimal } from "../../../utils/utilities";
import TopNavigation from "../../../components/TopNavigation";
import ListBank from "./listBank";
import Preview from "./preview";
import { InformationDialog } from "../../../components/DialogCollection";
import * as Assets from "./../../../utils/svg_assets";

const CashTransfer = (props) => {
  const {
    getRewardDetails,
    reward_vouchers_detail: rewardDetail,
    redemptionInquiry,
  } = props;
  const { points } = rewardDetail;
  const { amount } = rewardDetail.options;
  const navigate = useNavigate();
  const [payload, setPayload] = useState({
    code: "",
    accountNumber: "",
    amount,
  });

  const { id } = useParams();

  const [selectedBank, setSelectedBank] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [message, setMessage] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [dataInquiry, setDataInquiry] = useState({});

  useEffect(() => {
    getRewardDetails({ id });
  }, []);

  const showMessage = (msg) => {
    setIsOpenDialog(true);
    setMessage(`Please enter ${msg}`);
  };

  const onSubmit = () => {
    if (payload.code === "") {
      showMessage("bank code");
      return;
    }
    if (payload.accountNumber === "") {
      showMessage("account number");
      return;
    }
    if (payload.amount === "") {
      showMessage("amount");
      return;
    }

    const bodyRequest = {
      reward: id,
      user_data: {
        bank_code: payload.code,
        bank_account_number: payload.accountNumber,
      },
    };
    redemptionInquiry(bodyRequest).then((response) => {
      if (response.status === 200) {
        setDataInquiry(response.data.data);
        setIsPreview(true);
      } else {
        toast.error(response.message.message, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }
    });
  };

  return (
    <Base>
      <TopNavigation
        titlePage={isOpen ? "Bank Code" : "Cash Transfer to Bank Account"}
        setBorder={true}
        iconLeft={Assets.iconBack}
        onClick={() => {
          if (isOpen) setIsOpen(!setIsOpen);
          if (isPreview) setIsPreview(!setIsPreview);
          navigate(-1);
        }}
      />
      <Container>
        {isOpen ? (
          <ListBank
            isWebview={false}
            onClick={(value) => {
              setIsOpen(false);
              setPayload({ ...payload, code: value.code });
              setSelectedBank(value);
            }}
          />
        ) : isPreview ? (
          <Preview
            data={dataInquiry}
            onPreview={(value) => setIsPreview(value)}
          />
        ) : (
          <div>
            <div className="mt-3">
              Please enter your bank code and bank account number. Make sure
              your bank account is valid.
            </div>

            <div
              className="text-danger py-3 text-decoration-underline"
              onClick={() => setIsOpen(true)}
            >
              View bank code
            </div>

            <Form.Group as={Col} className="group">
              <Row>
                <Col xs={4}>
                  <Form.Label className="fs-14">Bank Code</Form.Label>
                  <Form.Control
                    type="text"
                    onKeyPress={(event) => numberOnly(event)}
                    maxLength="4"
                    value={payload.code}
                    onChange={(e) =>
                      setPayload({ ...payload, code: e.target.value })
                    }
                  />
                </Col>
                <Col>
                  <Form.Label className="fs-14">Account Number</Form.Label>
                  <Form.Control
                    type="text"
                    onKeyPress={(event) => numberOnly(event)}
                    maxLength="20"
                    value={payload.accountNumber}
                    onChange={(e) =>
                      setPayload({ ...payload, accountNumber: e.target.value })
                    }
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <Form.Group as={Col}>
                    <Form.Label className="fs-14">Amount</Form.Label>
                    <InputGroup className="mb-3 password form-control-without-border">
                      <div className="fs-18 d-flex align-items-center">Rp</div>
                      <Form.Control
                        className="input-password border-0 form-control-without-border"
                        type="text"
                        onKeyPress={(event) => numberOnly(event)}
                        value={priceDecimal(payload.amount)}
                        readOnly
                        onChange={(e) => {
                          setPayload({ ...payload, amount: e.target.value });
                        }}
                      />
                    </InputGroup>
                    <div className="fs-14">
                      *{priceDecimal(points)} pts required
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Button
                variant="danger"
                className="btn-change border-0 mt-4"
                onClick={onSubmit}
              >
                Continue
              </Button>

              <Button
                variant="outline-danger"
                className="w-100 border-0 mt-2"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
            </Form.Group>
          </div>
        )}

        <InformationDialog
          message={message}
          closeLabel="OK"
          show={isOpenDialog}
          onHide={() => setIsOpenDialog(!isOpenDialog)}
        />
      </Container>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  reward_vouchers_detail: state.RewardSM.reward_vouchers_detail,
});

const mapDispatchToProps = (dispatch) => ({
  getRewardDetails: dispatch.RewardSM.getRewardDetails,
  redemptionInquiry: dispatch.RedeemSM.redemptionInquiry,
});

export default connect(mapStateToProps, mapDispatchToProps)(CashTransfer);
